import React, { useState, useEffect } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { DeleteCategory, GetAllCategory } from '../services/categoryservice';

function CategoryList() {
    const [data, setData] = useState();
    const location = useLocation();    
    const { successMessage } = location.state || {};
    let navigate = useNavigate();  

    useEffect(() => {
        fillData();
        toast(successMessage);
    }, []); 

    const fillData  = async () => {
        try {
            const catList = await GetAllCategory();
            const jsonCatList = JSON.parse(catList);
            setData(jsonCatList);             
          } catch (error) {
            console.error('Error fetching the data:', error);
          }
    }

    const handleDelete = async(catId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this category?");
            if (isConfirmed) {
                const data = await DeleteCategory(catId);
                await fillData();
                toast("Category deleted successfully!");
            }
    };
    
    const handleEdit = (id) => {  
        navigate('/category/add?pk='+id);
    };

    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <p class="card-title mb-0">Top Categories</p>
                                </div>
                                <div class="col-md-6 right-align">
                                <Link to="/category/add" className='nav-link'>
                                    <button type="submit" class="btn btn-primary me-2">New Category</button>
                                </Link>
                                </div>
                            </div>
                            
                            <div class="table-responsive">
                                <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr>
                                            <th>Pk</th>
                                            <th>Title</th>
                                            <th>Paramlink</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data?.map((item) => (
                                            <tr>
                                                <td>{item.pk}</td>
                                                <td class="font-weight-bold">{item.title}</td>
                                                <td>{item.paramlink}</td>
                                                <td>
                                                    <i
                                                    className="mdi mdi-tooltip-edit mdi-big font20 pointer"
                                                    title="Edit Record"
                                                    onClick={() => handleEdit(Number(item.pk))}
                                                    ></i>
                                                    <i
                                                    className="mdi mdi-delete mdi-big font20 pointer"
                                                    title="Delete Record"
                                                    onClick={() => handleDelete(item.pk)}
                                                    ></i>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}
export default CategoryList;